import queryString from 'query-string';
/**
 * Create an image URL for ImageProcessor
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image || !image.src) {
        return '';
    }
    /**
     * Remove any query param string to ensure paramsString is applied correctly and
     * there are no double definitions (setting a param twice prevents any tranformations)
     */
    const imageSource = image.src.split('?')[0];
    const params = {
        bgcolor: imageParams.bgcolor,
        height: getImageHeight(imageParams),
        // Define default quality as 95 to ensure some reduction in size for all but the smallest images
        quality: imageParams.width && imageParams.width > 400 ? 95 : undefined,
        rmode: imageParams.rmode ?? 'crop',
        rxy: image.focalPoint ? `${image.focalPoint.left},${image.focalPoint.top}` : undefined,
        width: getImageWidth(imageParams),
    };
    const paramsString = queryString.stringify(params);
    return `${imageSource}${paramsString ? `?${queryString.stringify(params)}` : ''}`;
}
const getImageWidth = (imageParams) => {
    if (imageParams.width) {
        return imageParams.width;
    }
    if (imageParams.widthratio && imageParams.height) {
        return imageParams.widthratio * imageParams.height;
    }
    return undefined;
};
const getImageHeight = (imageParams) => {
    if (imageParams.height) {
        return imageParams.height;
    }
    if (imageParams.heightratio && imageParams.width) {
        return imageParams.heightratio * imageParams.width;
    }
    return undefined;
};
